module.exports = __webpack_public_path__ + "static/media/belt.6f58b4a0.jpg";